import * as React from 'react';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import {FcCalendar} from 'react-icons/fc';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

export default function ResponsiveDatePickers(props) {
  const [startDate, setStartDate] = React.useState(dayjs(props.valueInField));
  const handleChange = (value) => {
    //alert("VAL: " + value + " EVENT: " + event.target.id)
    //console.log(typeof(value))
    //props.triggerUpdateInParent(props.id, value)
    //setStartDate(value)
    //alert("VALUE: " + value)
    var value2;
    if (props.valueInField == "") value2 = value.$d;
    else value2 = new Date(props.valueInField)
    //var value2 = new Date(props.valueInField)
    props.triggerUpdateInParent(props.id, value.$d)
    console.log("VALUE!!!")
    console.log(value.$d)
    setStartDate(value.$d)
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div>
          {props.required ? <span className="required-field-datepicker">*</span> : <span className="unrequired-field">*</span>}
        <MobileDatePicker
          label={props.label}
          className='date-pick-advanced required-date-pick-advanced'
          minDate={dayjs('2000-01-01')}
          /*maxDate={dayjs('2023-01-01')}*/
          maxDate={props.maxDate}
          value={startDate}
          onChange={(value) => handleChange(value)}
          renderInput={(params) => <TextField {...params} />}
        />
        </div>
        
    </LocalizationProvider>
  );
}

/*
<LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack spacing={3}>
        <MobileDatePicker
          label="For mobile"
          value={value}
          onChange={(newValue) => {
            setValue(newValue);
          }}
          renderInput={(params) => <TextField {...params} />}
        />
        <DesktopDatePicker
          label="For desktop"
          value={value}
          minDate={dayjs('2017-01-01')}
          onChange={(newValue) => {
            setValue(newValue);
          }}
          renderInput={(params) => <TextField {...params} />}
        />
        <DatePicker
          disableFuture
          label="Responsive"
          openTo="year"
          views={['year', 'month', 'day']}
          value={value}
          onChange={(newValue) => {
            setValue(newValue);
          }}
          renderInput={(params) => <TextField {...params} />}
        />
      </Stack>
    </LocalizationProvider>
*/
